/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2025
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Type of the Media Alignment
 */
export enum MEDIA_ALIGNMENT {
  /**
   * Right alignment
   */
  RIGHT = 'right',

  /**
   * Left alignment
   */
  LEFT = 'left',
}

/**
 * Type of color scheme
 */
export enum COLOR_SCHEME {
  /**
   * Regular color scheme
   */
  REGULAR = 'regular',

  /**
   * Inverse color scheme
   */
  INVERSE = 'inverse',

  /**
   * Cyan color scheme
   */
  CYAN = 'cyan',

  /**
   * Purple color scheme
   */
  PURPLE = 'purple',
}
